import { ITimesheetDayRepository } from "domain/contracts/timesheet-day.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { TimesheetDay } from "domain/entities/timesheet-day";
import { TimesheetDayInputFilter } from "domain/models/timesheet-day-input-filter";

class TimesheetDayRepository implements ITimesheetDayRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/timesheetDay/${id}`);
    return response.data;
  }

  async deleteBulk(ids: string[]): Promise<Message<boolean>> {
    const response = await httpClient.post(`/timesheetDay/bulk-delete`, {
      data: { ids },
    });
    return response.data;
  }

  async create(input: TimesheetDay): Promise<Message<TimesheetDay>> {
    const response = await httpClient.post(`/timesheetDay`, { data: input });
    return response.data;
  }

  async createAll(input: TimesheetDay[]): Promise<Message<TimesheetDay[]>> {
    const response = await httpClient.post(`/timesheetDay/bulk`, {
      data: input,
    });
    return response.data;
  }

  async update(input: TimesheetDay): Promise<Message<boolean>> {
    const response = await httpClient.put(`/timesheetDay/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(
    filter: TimesheetDayInputFilter
  ): Promise<Message<TimesheetDay[]>> {
    const response = await httpClient.get(`/timesheetDay`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<TimesheetDay>> {
    const response = await httpClient.get(`/timesheetDay/${id}`);
    return response.data;
  }
}

export default new TimesheetDayRepository();
